import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import Textblock from '../../../../components/textblock'
import { Column, Row } from '../../../../components/layout-row'
import DoodleBackground from '../../../../components/doodle-background'

import styles from './features.module.scss'
import imgRealtime from './payroll-real-time.png'
import imgAgi from './payroll-agi.png'
import imgReimbursement from './payroll-reimbursement.png'

const Features = () => (
  <div className={styles.root}>
    <DoodleBackground variant="bottomRight" />

    <Row id="feature-one">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Få en unik överblick av lönespecifikationer som beräknas i realtid och skapa standardlöner som gör att du slipper fylla i samma uppgifter varje månad. Yes, it’s magisk lönekörning."
              id="diy-payroll.features.1-description"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Enkelt att göra rätt" id="diy-payroll.features.1-sub-title" />}
          title={<FormattedMessage defaultMessage="Smartare lönekörningar" id="diy-payroll.features.1-title" />}
          variant="free"
        />
      </Column>

      <Column>
        <img alt="Dooer payroll in real time" src={imgRealtime} />
      </Column>
    </Row>

    <Row id="feature-two" top="second">
      <Column first>
        <img alt="Dooer payroll AGI integration" src={imgAgi} />
      </Column>

      <Column limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Dina AGI-rapporter skapas automatiskt och skickas enkelt in med ett klick, direkt från Dooer. Slipp ladda ner, logga in på Skatteverket och ladda upp."
              id="diy-payroll.features.2-description"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Slipp onödiga steg" id="diy-payroll.features.2-sub-title" />}
          title={<FormattedMessage defaultMessage="AGI med ett klick" id="diy-payroll.features.2-title" />}
          variant="free"
        />
      </Column>
    </Row>

    <Row id="feature-three">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Dina anställda fotar enkelt kvitton i Dooers app, laddar upp och du godkänner med några klick. Smidigt, både för dig och dina anställda som får pengarna samma dag."
              id="diy-payroll.features.3-description"
            />
          }
          subTitle={
            <FormattedMessage defaultMessage="För dig och dina anställda" id="diy-payroll.features.3-sub-title" />
          }
          title={<FormattedMessage defaultMessage="Rolig utläggshantering" id="diy-payroll.features.3-title" />}
          variant="free"
        />
      </Column>
      <Column>
        <img alt="Dooer payroll easy reimbursements" src={imgReimbursement} />
      </Column>
    </Row>
  </div>
)

export default Features
